//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { maxLength, required, requiredIf } from 'vuelidate/lib/validators'
import { escrowStatuses } from 'ct-constants'
import TextareaGroup from '~/components/form/TextareaGroup'
import InputGroup from '~/components/form/InputGroup'
import AxiosErrorHandler from '~/mixins/AxiosErrorHandler'
import ResumeForm from '~/components/profile/ResumeForm'

const resumeInitialForm = {
  fileId: null,
  name: null,
  public: true
}

export default {
  name: 'NewApplicationModal',
  components: {
    ResumeForm,
    InputGroup,
    TextareaGroup
  },
  mixins: [AxiosErrorHandler],
  props: {
    task: {
      type: Object,
      required: true
    },
    invitationId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      form: {
        letter: null,
        cryptoPayoutAddress: null,
        resumeId: null
      },
      resume: { ...resumeInitialForm },
      newApplication: null,
      loadingResumes: false,
      resumes: [],
      uploadingResume: false
    }
  },
  validations: {
    form: {
      letter: {
        required
      },
      resumeId: {
        required: requiredIf(function () {
          return this.task.requireResume
        })
      }
    },
    resume: {
      fileId: {
        required
      },
      name: {
        required,
        maxLength: maxLength(255)
      }
    }
  },
  computed: {
    /**
     * Get OK button label depending on new application
     * @returns {string}
     */
    okButtonLabel () {
      return this.newApplication ? 'boostVisibility' : 'apply_for_job'
    },

    /**
     * Is payout address input field enabled
     */
    payoutEnabled () {
      return !!this.task?.escrowPublic && this.task?.escrowBalance > 0 && this.task?.escrowStatus === escrowStatuses.ESCROW_SET
    },

    /**
     * Remap resumes to fit select input
     * @returns {{text: *, value: *}[]}
     */
    selectionResumes () {
      return this.resumes.map(r => ({
        value: r.id,
        text: r.name
      }))
    },

    /**
     * Show alert if task has agent
     * @return {boolean}
     */
    showAlert () {
      return !!(this.task?.escrowStatus === escrowStatuses.ESCROW_SET && this.task?.agentId)
    }
  },
  mounted () {
    this.loadResumes()
  },
  methods: {
    show () {
      this.$refs.applicationModal.show()
    },
    async handleModalApplyButton () {
      if (!this.newApplication) {
        this.$v.form.$touch()
        if (!this.$v.form.$invalid) {
          try {
            this.newApplication = await this.$store.dispatch('freelancerApplications/apply', {
              taskId: this.task.id,
              taskBcId: this.task.bcId,
              invitationId: this.invitationId,
              ...this.form
            })
            // fetch threads
            await this.$store.dispatch('chat/getThreads')

            // emit to socket that freelancer applied to task
            // this.$socket.emit('applied', this.newApplication)

            // register application on bc
            this.$smartContract.setApplicationProperties(this.task.bcId)
              .then(async (res) => {
                console.log(res)
                try {
                  const resBc = await this.$axios.put('/applications/regBcApplication', res)
                  console.log(resBc.data)
                } catch (err) {
                  console.error(err.response ? err.response.data : err)
                }
              })
              .catch(err => console.error(err))

            // show toast
            await this.$store.dispatch('ui/showNotification', {
              type: 'success',
              text: this.$t('freelancers.apply_success')
            })

            this.$gtag.event('new_application', {
              task: this.task.id
            })

            // reset input fields on modal
            this.letter = null
            this.cryptoPayoutAddress = null
          } catch (err) {
            await this.handleError(err)
          }
        }
      } else {
        await this.$router.push(this.localePath('/subscriptions/subscribe'))
      }
    },

    /**
     * Handle closing apply modal window
     */
    async handleModalHidden () {
      if (this.newApplication) {
        await this.$router.push(this.localePath(`/applications/${this.newApplication.id}`))
      }

      // reset application property
      this.newApplication = null
    },

    /**
     * Load freelancers resumes if resume is required on application
     * @returns {Promise<void>}
     */
    async loadResumes () {
      if (this.task?.requireResume && this.$auth.loggedIn && this.$store.getters['user/isFreelancer']) {
        this.loadingResumes = true
        const { data } = await this.$axios.get('/resumes')
        this.resumes = data.data
        this.loadingResumes = false
      }
    },

    /**
     * Handle change event from resume form
     * @param e
     */
    handleResumeChange (e) {
      this.resume = { ...e }
    },

    /**
     * Handle new resume form submit
     * When resume is created also add it to resumes list and preselect it
     * @returns {Promise<void>}
     */
    async handleResumeSubmit () {
      this.$v.resume.$touch()
      if (!this.$v.resume.$invalid) {
        try {
          this.uploadingResume = true
          const { data } = await this.$axios.post('/resumes', this.resume)

          // add resume to list
          this.resumes.push(data.data)

          // select it
          this.form.resumeId = data.data.id

          // close accordion
          this.$root.$emit('bv::toggle::collapse', 'newResumeAccordion')

          // reset form
          this.resume = { ...resumeInitialForm }

          this.uploadingResume = false
          await this.$store.dispatch('ui/showNotification', {
            type: 'success',
            text: this.$t('freelancers.resumeUploadSuccess')
          })
        } catch (err) {
          this.uploadingResume = false
          await this.handleError(err)
        }
      }
    }
  }
}
